/* tslint:disable */
/* eslint-disable */
/**
 * Public Track API
 * Public Track APIs provide customers access to their SPiDRs, Security Focuses and SPiDR Blueprints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const NISTCategory = {
    IdAmAssetManagement: 'ID.AM: Asset Management',
    IdBeBusinessEnvironment: 'ID.BE: Business Environment',
    IdGvGovernance: 'ID.GV: Governance',
    IdRaRiskAssessment: 'ID.RA: Risk Assessment',
    IdRmRiskManagementStrategy: 'ID.RM: Risk Management Strategy',
    IdScSupplyChainRiskManagement: 'ID.SC: Supply Chain Risk Management',
    PrAcIdentityManagementAuthenticationAndAccessControl: 'PR.AC: Identity Management, Authentication and Access Control',
    PrAtAwarenessAndTraining: 'PR.AT: Awareness and Training',
    PrDsDataSecurity: 'PR.DS: Data Security',
    PrIpInformationProtectionProcessesAndProcedures: 'PR.IP: Information Protection Processes and Procedures',
    PrMaMaintenance: 'PR.MA: Maintenance',
    PrPtProtectiveTechnology: 'PR.PT: Protective Technology',
    DeAeAnomaliesAndEvents: 'DE.AE: Anomalies and Events',
    DeCmSecurityContinuousMonitoring: 'DE.CM: Security Continuous Monitoring',
    DeDpDetectionProcesses: 'DE.DP: Detection Processes',
    RsAnAnalysis: 'RS.AN: Analysis',
    RsCoCommunications: 'RS.CO: Communications',
    RsImImprovements: 'RS.IM: Improvements',
    RsMiMitigation: 'RS.MI: Mitigation',
    RsRpResponsePlanning: 'RS.RP: Response Planning',
    RcCoCommunications: 'RC.CO: Communications',
    RcImImprovements: 'RC.IM: Improvements',
    RcRpRecoveryPlanning: 'RC.RP: Recovery Planning'
} as const;
export type NISTCategory = typeof NISTCategory[keyof typeof NISTCategory];


export function NISTCategoryFromJSON(json: any): NISTCategory {
    return NISTCategoryFromJSONTyped(json, false);
}

export function NISTCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): NISTCategory {
    return json as NISTCategory;
}

export function NISTCategoryToJSON(value?: NISTCategory | null): any {
    return value as any;
}

